import LawyerOfficeApplicationRepository from './../api/repositories/LawyerOfficeApplicationRepository';
import DamageAssessorApplicationRepository from './../api/repositories/DamageAssessorApplicationRepository';
// import {Damageassessor} from './../api/generated';

export default {
	state: {
		lawyerOfficeApplications: undefined,
		damageAssessorApplication: undefined,
	},
	getters: {
		getLawyerOfficeApplications(state) {
			return state.lawyerOfficeApplications;
		},
		getDamageAssessorApplications(state) {
			return state.damageAssessorApplication;
		},
	},
	mutations: {
		setLawyerOfficeApplications(state, payload) {
			state.lawyerOfficeApplications = payload;
		},
		setDamageAssessorApplications(state, payload) {
			state.damageAssessorApplication = payload;
		},
	},
	actions: {
		updateLawyerOfficeApplications({ commit, dispatch, getters }, payload) {
			commit('setLawyerOfficeApplications', undefined);
			LawyerOfficeApplicationRepository.index().then(response => {
				commit(
					'setLawyerOfficeApplications',
					response.data.data.filter(e => !e.lawyerOffice),
				);
			});
		},
		updateDamageAssessorApplications({ commit, dispatch, getters }, payload) {
			commit('setDamageAssessorApplications', undefined);
			DamageAssessorApplicationRepository.index().then(response => {
				commit(
					'setDamageAssessorApplications',
					response.data.data.filter(e => !e.damageAssessorCompany),
				);
			});
		},
	},
};
